import React, { Component } from 'react';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import { browserHistory } from 'react-router';

import {
  queryDeleteMaterialBorrow,
  queryMaterialBorrowWorkflow,
  querySaveMaterialBorrow,
} from '@api/administrative/material';

import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    this.materialBorrowWorkflow();
  }

  /**
   * 提交资料借用
   */
  handSubmit = item => {
    this.saveMaterialBorrow(item);
  };

  materialBorrowWorkflow = params => {
    const { instance } = this.state;
    queryMaterialBorrowWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveMaterialBorrow = item => {
    this.setState({ isSubmitting: true });
    querySaveMaterialBorrow(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isSubmitting: false });
      } else if (res.message.indexOf('\n') === -1) {
        message.error(res.message);
        this.setState({ isSubmitting: false });
      } else {
        this.setState({
          isSubmitting: false,
        });
      }
    });
  };

  hideModal = () => {
    this.setState({});
  };

  deleteMaterialBorrow = () => {
    queryDeleteMaterialBorrow({
      uuid: this.props.data.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { isSubmitting, instance } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <FormBase
          data={dataInfo}
          handSubmit={this.handSubmit}
          handleDelete={this.deleteMaterialBorrow}
          isSubmitting={isSubmitting}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/administrative/material/borrow/PageEdit.js